import React, { useMemo } from 'react';

import BrokerFilter from 'components/search_sidebar/broker_filter';
import Wrapper from './wrapper';

import type { Filters } from './types';

type Slice = Pick<Filters, 'dealUserId'>;
interface Props extends Slice {
  users: { id: number; name: string }[];
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ dealUserId, users, onChange }: Props) {
  const options = useMemo(() => [{ name: 'All Brokers' }, ...users], []);

  return (
    <Wrapper>
      <BrokerFilter
        autoWidth
        brokers={options}
        menuPosition="fixed"
        selectedBrokerId={dealUserId}
        onChange={user => onChange({ dealUserId: user?.id || null })}
        onClear={dealUserId ? () => onChange({ dealUserId: null }) : null}
      />
    </Wrapper>
  );
}
